var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-state-date"},[_c('DatePicker',{staticClass:"date-picker",attrs:{"value":_vm._value,"placeholder":"選擇日期","format":_vm.format},on:{"input":function($event){return _vm.$_onInput($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }